"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachmentList = useAttachmentList;
const swr_1 = __importDefault(require("swr"));
const useAttachmentClient_1 = require("./useAttachmentClient");
/**
 * Calls `attachmentClient.list` and returns an SWR response.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param entityId - entity id, this is optional, if not set backend will not be called and result will not be returned
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object
 */
function useAttachmentList(entity, entityId, baseUrl, tokenProvider, config) {
    const attachmentClient = (0, useAttachmentClient_1.useAttachmentClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)(entityId ? ['/platform/api/v1/attachment/list', entity, entityId] : null, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async ([_, entity, entityId]) => {
        return entityId ? attachmentClient.list({ entity, entityId }) : undefined;
    }, config ?? {
        revalidateOnFocus: false,
    });
}
